import Header from "./Header";
import Footer from "./Footer";
import TopTicker from "./TopTicker";
import AdStrip from "./AdStrip";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#faf6ef]">
      <TopTicker />
      <Header />
      <AdStrip />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
